export const filterObjectValues = (array, value, limit = null) => {
    let count = 0
    return [...array].filter(inv => {
        if (limit && count >= limit) return false;
        let add = false;
        for (const k in Object.keys(inv)) {
          const key = Object.keys(inv)[k];
          if (
            inv[key] &&
            inv[key].includes &&
            inv[key].toLowerCase().includes(value.toLowerCase())
          ) {
            count++;
            add = true;
            break;
          }
        }
        return add;
      });
}